angular.module('ihestiaCommonDirectives.baseUpload', [
  'lsnBase.md5'
  ]);
